<div id="main-wrapper">
    <div id="main-content">
        <div id="menu-wrapper">
            <img src="assets/shared/logos/portal-admin-logo.svg"/>
            <app-menu-3 [menuConfig]="menuConfig">
            </app-menu-3>
        </div>
        <div id="content-wrapper">
            <div id="header-wrapper">
                <div class="header">
                    <div class="header-block icons">
                        <app-dropdown
                            [invert]="true"
                            dropDownId="cm-myPortal-dropdown"
                            tabindex="0"
                            image="/assets/centralisedManagement/icons/portal.svg"
                            titleAlign="right"
                            [contentWidth]="180"
                            hintText="{{'portal' | myLbTranslate}}">
                            <div class="drop-container-html">
                                <ng-template [ngTemplateOutlet]="myPortal"></ng-template>
                            </div>
                        </app-dropdown>
                    </div>
                    <div class="header-block burger-menu">
                        <app-burger-menu-3 [menuConfig]="menuConfig">
                        </app-burger-menu-3>
                    </div>
                </div>
            </div>
            <div id="page"> <!-- Required as unable to apply 100% to the router-outlet -->
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>

<ng-template #myPortal>
    <div class="menu-item-wrapper" (click)="openLogoutModal()">
        <div id="menu-logout-item" class="menu-image-wrapper">
            <img ngSrc="/assets/centralisedManagement/icons/logout.svg" alt="log out" height="19" width="19">
        </div>
        <span>{{ 'logout' | myLbTranslate }}</span>
    </div>
</ng-template>

<!-- Drawer holder -->
<app-drawer></app-drawer>

<!-- TODO when services are running -->
<!--<app-relogin></app-relogin>-->

<app-modal-wrapper
    [isOverlayBlurred]="true"
    [isOverlayClickable]="false"
    modalTitle="logout_confirmation"
    modalId="logoutConfirm"
    style="user-select: none;"
    footerButtonAlignment="content-center">
    <app-modal-body>
        <p>{{ 'confirm_logout' | myLbTranslate }}</p>
    </app-modal-body>
    <app-modal-footer>
        <button id="logout" class="primary" (click)="logout()">
            {{ 'logout' | myLbTranslate }}
        </button>
    </app-modal-footer>
</app-modal-wrapper>
